import { render, staticRenderFns } from "./group-invite-me.vue?vue&type=template&id=04e152af"
import script from "./group-invite-me.vue?vue&type=script&lang=js"
export * from "./group-invite-me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports